import { watch } from 'vue';
import { getCourseId } from './SCORM';
import findTopWindow from './findTopWindow';

export default function useFavicon(content: Content) {
  if (import.meta.env.DEV) {
    const addFavicon = () => {
      const firstPage = document.querySelector('.page');
      // exit if the course isnt ready

      if (!firstPage) return;

      const getColor = (name: string, fallback: string) => {
        const rgb = window.getComputedStyle(firstPage).getPropertyValue(name);

        return name ? `rgb(${rgb})` : fallback;
      };

      try {
        const d = findTopWindow({ withOpeners: true })?.document || document;
        const existing = d.getElementById('favicon');

        const el = d.createElement('link');
        el.id = 'favicon';

        const color = getColor('--color-primary-500', '#888');
        const shadow = getColor('--color-primary-700', '#333');

        const id = (getCourseId() ?? '').toString();

        const sink =
          '<path d="m4.12 17.6a3.38 3.38 0 0 0 3.38 3.38h9a3.38 3.38 0 0 0 3.38-3.38v-1.12h-15.8zm16.3-4.5h-3.38v-1.12h2.25a0.562 0.562 0 0 0 0.562-0.562v-0.562a0.562 0.562 0 0 0-0.562-0.562h-2.81a1.12 1.12 0 0 0-1.12 1.12v1.69h-2.25v-6.75a1.12 1.12 0 0 1 2.25 0v0.562a0.562 0.562 0 0 0 0.562 0.562h1.12a0.562 0.562 0 0 0 0.562-0.562v-0.562a3.38 3.38 0 0 0-4.05-3.31c-1.6 0.311-2.7 1.81-2.7 3.44v6.62h-2.25v-1.69a1.12 1.12 0 0 0-1.12-1.12h-2.81a0.562 0.562 0 0 0-0.562 0.562v0.562a0.562 0.562 0 0 0 0.562 0.562h2.25v1.12h-3.38a0.562 0.562 0 0 0-0.562 0.562v1.12a0.562 0.562 0 0 0 0.562 0.562h16.9a0.562 0.562 0 0 0 0.562-0.562v-1.12a0.562 0.562 0 0 0-0.562-0.562z" fill="#fff"/>';

        const text =
          id.length > 4
            ? // 6 digits on two lines
              `<text x='6' y='5' style='fill: white; font: 900 11px monospace;letter-spacing:0.1ch;text-shadow: 1px 1px 4px ${shadow};' textLength='36' lengthAdjust='spacingAndGlyphs'>` +
              `<tspan x="3.5" dy="6">${id.slice(0, -3)}</tspan>` +
              `<tspan x="3.5" dy="9">${id.slice(-3)}</tspan>` +
              `</text>`
            : // one line
              `<text x='3' y='17' style='fill: white; font: 900 18px monospace;letter-spacing:0.1ch;text-shadow: 1px 1px 4px ${shadow};' textLength='18' lengthAdjust='spacingAndGlyphs'>${id}</text>`;

        const content = id === '0' ? sink : text;

        const svg = `<svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'><rect x='0' y='0' width='24' height='24' rx='4' fill='${shadow}'/><rect x='0' y='0' width='24' height='23' rx='4' fill='${color}' />${content}</svg>`;

        el.rel = 'icon';
        el.setAttribute('sizes', 'any');
        el.type = 'image/svg+xml';
        el.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;

        existing?.remove();

        d.head.appendChild(el);
      } catch (e) {
        console.warn(e);
      }
    };

    setTimeout(addFavicon, 1e3);
    setTimeout(addFavicon, 5e3);

    watch(
      () => content.course.primary,
      () => {
        setTimeout(addFavicon, 500);
      }
    );
  }
}
